export default "__VITE_ASSET__GQwI8Kr3__"